
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vioc-ES",
      function () {
        return require("private-next-pages/vioc-ES/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vioc-ES"])
      });
    }
  